import React from 'react';

import type {
  AutocompleteApi,
  AutocompleteCollection,
} from '@algolia/autocomplete-core';

import type { DocSearchHit } from '../../../types';

import { Result } from './Result';
import { ResultsTitle } from './ResultsTitle';

interface Props
  extends AutocompleteApi<
    DocSearchHit,
    React.FormEvent,
    React.MouseEvent,
    React.KeyboardEvent
  > {
  title?: string;
  collection: AutocompleteCollection<DocSearchHit>;
  renderIcon: (props: { item: DocSearchHit; index: number }) => React.ReactNode;
  renderAction: (props: {
    item: DocSearchHit;
    runDeleteTransition: (cb: () => void) => void;
    runFavoriteTransition: (cb: () => void) => void;
  }) => React.ReactNode;
  onItemClick: (item: DocSearchHit) => void;
}

export const Results: React.FC<Props> = ({
  title,
  collection,
  getListProps,
  renderAction,
  renderIcon,
  getItemProps,
  onItemClick,
}) => {
  if (!collection || collection.items.length === 0) {
    return null;
  }

  return (
    <section className="DocSearch-Hits">
      <ResultsTitle collection={collection} title={title} />
      <ul {...getListProps()}>
        {collection.items.map((item, index) => {
          return (
            <Result
              key={item.objectID}
              item={item}
              index={index}
              collection={collection}
              onItemClick={onItemClick}
              renderAction={renderAction}
              renderIcon={renderIcon}
              getItemProps={getItemProps}
            />
          );
        })}
      </ul>
    </section>
  );
};
